export class Configs {
	//Themes
	public static readonly body: string = "body";
	public static readonly theme: string = "theme";
	public static readonly default: string = "default";
	public static readonly light: string = "light";
	public static readonly dark: string = "dark";
	public static readonly contrast: string = "contrast";

	//KeyCodes
	public static readonly keyCodeEnter: number = 13;
	public static readonly keyCodeSpace: number = 32;
}

export class Routes {
    public static readonly teamsApp: any = {
        listServentias: '/list-serventias',
        painelAtendimento: '/painel-atendimento',
        painelAtendimentoEquipe: '/painel-atendimento-equipe',
        agendamento: '/agendamento',
        formBalcaoVirtual: '/form-balcao-virtual',
        settings: '/settings',
        configMeetingExtensibility: '/config-meeting-extensibility',
        inMeetingPanel: '/in-meeting-panel',
        inMeetingAlert: '/in-meeting-alert',
        postMeetingPanel: '/post-meeting-panel',
        errorPage: '/errorpage',
        signin: '/signin',
        signinSimpleStart: '/signin-simple-start',
        signinSimpleEnd: '/signin-simple-end',
        configTab: '/config-tab',
        dashboards: '/dashboards',
    };

    public static readonly publicApp: any = {
        root: '/',
        meetingQueue: '/meeting-queue',
        meetingQueueAuth: '/meeting-queue-auth',
        acs: '/acs',
        loginRedirect: '/login-redirect',
        avisoForaHorario: '/aviso-fora-horario',
        avisoIndisponivel: '/aviso-indisponivel',
        queueLimit: '/aviso-limite-fila',
        accessDisabled: '/aviso-acesso-desabilitado',
        meetings: '/meetings',
        errorPage: '/errorpage',
    };
}